﻿﻿import { CancerType } from '../enums/index';
import { RemissionStatus } from '../enums/index';

export interface ICancerRejection {
    cancerType: CancerType;
    remissionStatus: RemissionStatus;
}
